/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Knee_LabelInputs */

const en_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knee`)
};

const fr_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genou`)
};

const de_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knie`)
};

const it_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginocchio`)
};

const ru_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колено`)
};

const es_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodilla`)
};

const zh_cn2_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`膝盖`)
};

const ja_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`膝`)
};

const hi_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घुटना`)
};

const pt_pt2_audio_description_export_automix_knee_label = /** @type {(inputs: Audio_Description_Export_Automix_Knee_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joelho`)
};

/**
* | output |
* | --- |
* | "Knee" |
*
* @param {Audio_Description_Export_Automix_Knee_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_knee_label = /** @type {((inputs?: Audio_Description_Export_Automix_Knee_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Knee_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_knee_label(inputs)
	if (locale === "de") return de_audio_description_export_automix_knee_label(inputs)
	if (locale === "it") return it_audio_description_export_automix_knee_label(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_knee_label(inputs)
	if (locale === "es") return es_audio_description_export_automix_knee_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_knee_label(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_knee_label(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_knee_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_knee_label(inputs)
	return en_audio_description_export_automix_knee_label(inputs)
});